// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5p-6";
export var headerCell = "_5p-2";
export var rowWrapper = "_5p-4";
export var stickyAggregationCell = "_5p-a";
export var stickyAggregationRow = "_5p-7";
export var stickyColumnCell = "_5p-9";
export var stickyColumnHeaderCell = "_5p-8";
export var table = "_5p-1";
export var virtualRowWrapper = "_5p-5";
export var virtualTableContainer = "_5p-0";
export var white = "_5p-3";